import { render, staticRenderFns } from "./expand-button.vue?vue&type=template&id=2f57339b&"
import script from "./expand-button.vue?vue&type=script&lang=js&"
export * from "./expand-button.vue?vue&type=script&lang=js&"
import style0 from "./expand-button.vue?vue&type=style&index=0&id=2f57339b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports